import { FileCheck, Search, ShieldCheck } from 'lucide-react'

export interface RelayRequirement {
  name: string
  limit: string
  who: string
}

export interface RelayFaqItem {
  question: string
  answer: string
}

export const RELAY_REQUIREMENTS: RelayRequirement[] = [
  { name: 'Commercial Auto Liability', limit: '$1,000,000 per occurrence', who: 'Everyone hauling on Relay' },
  { name: 'Cargo coverage', limit: '$100,000', who: 'Everyone hauling on Relay' },
  {
    name: 'General Liability',
    limit: '$1,000,000 per occurrence / $2,000,000 aggregate',
    who: 'Everyone hauling on Relay',
  },
  {
    name: 'Trailer Interchange coverage',
    limit: '$50,000',
    who: 'If you pull Amazon trailers with a tractor (power only)',
  },
  {
    name: 'Workers Compensation',
    limit: 'State minimum + $100,000 Employers Liability',
    who: 'If you have W-2 employees',
  },
]

export const RELAY_CHECKS = [
  'Your MC number has been active for at least 180 days',
  'Your FMCSA safety rating is Satisfactory, Unrated, or not rated yet',
  'Your insurance provider has filed your coverage with FMCSA, and it matches what you gave Relay',
]

export const RELAY_VALUE_PROPS = [
  {
    key: 'built-for-relay',
    icon: <ShieldCheck />,
    title: 'Quotes built for Relay',
    body: 'Every quote we bring you meets Amazon’s limits, including Trailer Interchange coverage if you run power only. No guessing on your end.',
  },
  {
    key: 'we-work-for-you',
    icon: <Search />,
    title: 'We work for you',
    body: 'Cai is an insurance broker, not an agent for one company. We compare A-rated insurance providers side by side and bring you the best price.',
  },
  {
    key: 'instant-cois',
    icon: <FileCheck />,
    title: 'COIs are instant',
    body: 'Need a certificate of insurance for Amazon, a new yard or a leasing company? Get it from Cai right away instead of waiting on a callback.',
  },
]

export const RELAY_FAQS: RelayFaqItem[] = [
  {
    question: 'What insurance do I need for Amazon Relay?',
    answer:
      'Commercial Auto Liability at $1,000,000 per occurrence, $100,000 in Cargo coverage, and General Liability at $1,000,000 per occurrence with a $2,000,000 aggregate. Add $50,000 in Trailer Interchange coverage if you pull Amazon trailers, and Workers Compensation if you have W-2 employees.',
  },
  {
    question: 'Relay flagged my insurance. What do I do?',
    answer:
      'Usually a limit is too low or your FMCSA filing doesn’t match what Relay has on file. Send us your declarations page (the summary page of your policy that lists your coverages and limits). We’ll find the gap, get it fixed, and make sure your insurance provider updates your filing with FMCSA.',
  },
  {
    question: 'Do I need Trailer Interchange coverage?',
    answer:
      'If you run a tractor and pull Amazon’s trailers, yes. It covers damage to a trailer you don’t own while it’s hooked to your truck. If you only run a box truck, you don’t need it.',
  },
  {
    question: 'Is $100,000 in Cargo coverage enough?',
    answer:
      'It’s enough to get approved. It may not be enough to cover a full trailer of high-value freight. We’ll show you quotes at higher limits so you can decide.',
  },
  {
    question: 'Can box trucks haul for Relay?',
    answer: 'Yes. Relay accepts box trucks, day cabs, sleepers and reefers. Cargo vans aren’t allowed.',
  },
  {
    question: 'Can I switch to Cai before my policy renews?',
    answer:
      'Yes. You sign a Broker of Record form, which gives Cai permission to shop for quotes on your behalf. It doesn’t cancel or change your current policy.',
  },
]
